import { Enrolment } from '@/models/enrolment';
import { Partnership } from '@/models/partnership';

export class EnrolmentReviewStartedEventPayload {
	public constructor(
		public readonly partnership: Partnership,
		public readonly enrolments: Enrolment[]
	) {}
}
